export function deadlineLabel(settings) {
  return new Intl.DateTimeFormat("en-US", {
    month: "long",
    day: "numeric",
    timeZone: "America/Boise",
  }).format(
    new Date(settings?.deadline || "2026-12-05T07:00:00Z").getTime() - 1,
  );
}
